exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".describe-text[data-v-6a22650d]{line-height:40px}.describe-text div[data-v-6a22650d]{font-size:16px}.describe-text .ivu-col-span-8[data-v-6a22650d]{font-weight:bolder;color:#2d8cf0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a22650d","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/base/scan/ScanNumber.vue
// module id = 7PNz
// module chunks = 2